import { render } from "./IndicatorsSales.vue?vue&type=template&id=553b1d4b&scoped=true"
import script from "./IndicatorsSales.vue?vue&type=script&lang=js"
export * from "./IndicatorsSales.vue?vue&type=script&lang=js"

import "./IndicatorsSales.vue?vue&type=style&index=0&id=553b1d4b&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553b1d4b"]])

export default __exports__